import clsx from 'clsx';

import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

import type { MenuSectionItemOwnerState } from './types';

export function getMenuSectionItemUtilityClass(slot: string): string {
  return generateUtilityClass('MenuSectionItem', slot);
}

export const menuSectionItemClasses = generateUtilityClasses('MenuSectionItem', [
  // 고정 클래스 (target)
  'root',
  'header',
  'title',
  'subheader',
  'expandIcon',
  'content',
  'divider',

  // 동적 클래스 (getDynamicClasses)
  'expanded',
  'expandable',
  'disabled',
]);

/**
 * OwnerState 기반 동적 클래스 반환
 *
 * @param ownerState - 컴포넌트 상태
 * @returns 동적 클래스 문자열
 */
export function getDynamicClasses(ownerState: MenuSectionItemOwnerState): string {
  return clsx({
    [menuSectionItemClasses.expanded]: ownerState.expanded,
    [menuSectionItemClasses.expandable]: ownerState.expandable,
    [menuSectionItemClasses.disabled]: ownerState.disabled,
  });
}
